export const CORPUS_SET_TYPE_MAP = {
  INITIAL: {
    value: 1,
    text: '原始语料集',
    color: 'volcano',
  },
  MACHINE_SCREENED: {
    value: 2,
    text: '机筛语料集',
    color: 'purple',
  },
  FINE_ANNOTATED: {
    value: 3,
    text: '精标语料集',
    color: 'lime',
  },
  FINE_SCREENED: {
    value: 4,
    text: '精筛语料集',
    color: 'blue',
  },
};

export const TASK_TYPE_MAP = {
  CRAWL: {
    value: 1,
    text: '抓取任务',
  },
  CLEAN: {
    value: 2,
    text: '清洗任务',
  },
};

export const CORPUS_TYPE_MAP = {
  IMAGE: {
    value: 1,
    text: '图片',
    color: 'blue',
  },
  // VIDEO: {
  //   value: 2,
  //   text: '视频',
  //   color: 'magenta',
  // },
};

export const CRAWL_TASK_TYPE_MAP = {
  ONE_TIME: {
    value: 1,
    text: '一次性抓取任务',
    color: 'lime',
  },
  // SCHEDULE: {
  //   value: 2,
  //   text: '定时抓取任务',
  //   color: 'blue',
  // },
};

export const CRAWL_TASK_STATUS_MAP = {
  UNKNOWN: {
    value: 0,
    text: '未知',
    color: 'red',
  },
  PENDING: {
    value: 1,
    text: '待运行',
    color: 'gold',
  },
  TRIAL_RUNNING: {
    value: 2,
    text: '试运行中',
    color: 'lime',
  },
  TRIAL_COMPLETED: {
    value: 3,
    text: '试运行完成',
    color: 'success',
  },
  RUNNING: {
    value: 4,
    text: '运行中',
    color: 'lime',
  },
  COMPLETED: {
    value: 5,
    text: '已完成',
    color: 'green',
  },
  OFFLINE: {
    value: 6,
    text: '已下线',
    color: 'red',
  },
};

export const TASK_MODULE_EXEC_MAP = {
  UNKNOWN: {
    value: 0,
    text: '未知',
    color: 'red',
  },
  PENDING: {
    value: 1,
    text: '待运行',
    color: 'gold',
  },
  RUNNING: {
    value: 2,
    text: '运行中',
    color: 'lime',
  },
  SUCCESS: {
    value: 3,
    text: '成功',
    color: 'green',
  },
  ERROR: {
    value: 4,
    text: '失败',
    color: 'red',
  },
};

export enum TEMPLATE_TYPE_MAP {
  STRING_LIST = 1,
  STRING = 2,
}


export const CORPUS_ITEM_SOURCE_MAP = {
  RED_NOTE: {
    value: 'xhs',
    text: '小红书',
  },
  WEIBO: {
    value: 'wb',
    text: '微博',
  },
};